'use strict';
const angular = require('angular');
import TotalsController from './totals.controller';
import routes from './totals.routes';

export default angular.module('nomasvelloDashboardApp.totals', [])
    .config(routes)
    .controller('TotalsController', TotalsController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/totals/index.ts